module.exports = __webpack_public_path__ + "img/ai_icon.950ce259.png";